// Small pieces every page uses: the page wrapper, a loading state, and "show the problem instead of the page".

import type { Problem } from "../api/types";
import { t } from "../i18n/i18n";
import { createElement, createHeading } from "../ui/dom";
import { describeProblem } from "../ui/feedback";

/** Clears the container and returns a fresh page element with a title. */
export function startPage(container: HTMLElement, title: string): HTMLElement {
  const page: HTMLElement = createElement("main", "page");
  page.append(createHeading(1, title));
  container.replaceChildren(page);
  if (container.isConnected) {
    // A page that finished loading after the user moved on must not rename the newer page's tab.
    document.title = `${title} · ${t("app.productName")}`;
  }
  return page;
}

/** A "Loading…" line. */
export function createLoading(): HTMLParagraphElement {
  return createElement("p", "muted", t("app.loading"));
}

/** Replaces the page body with the problem's message. */
export function showPageProblem(page: HTMLElement, problem: Problem): void {
  const message: HTMLDivElement = createElement("div", "error-box", describeProblem(problem));
  message.setAttribute("role", "alert");
  page.append(message);
}

/** Removes everything after the title. */
export function clearPageBody(page: HTMLElement): void {
  while (page.children.length > 1 && page.lastElementChild !== null) {
    page.lastElementChild.remove();
  }
}
